
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { BalanceTypeSource } from '@/Sources';

  @Component({
    name: 'balance-type-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class BalanceTypeDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'Balance Type' }) public label!: string;
    @Prop({ default: '' }) public errorText!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;

    public source: BalanceTypeSource = new BalanceTypeSource();

    public get val(): string { return this.value; }
    public set val(value: string) {
      this.$emit('input', value);
    }
  }
